import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { CookiesPreferences } from "../src/platform/views/Settings/CookiePreferences";
import Provider from "../src/redux/Provider";

const CookiesPreferencesPage = ({ initialReduxState }) => {
  return (
    <Provider.Redux initialReduxState={initialReduxState}>
      <NextHead
        currentPath="/manage-cookies"
        title="Cookies Preferences"
        description="Manage your cookies preferences while using demyst.com."
      />
      <CookiesPreferences />
    </Provider.Redux>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CookiesPreferencesPage;
